import { ConsentBanner } from "./ConsentBanner.jsx";

export function ConsentProvider({ children }) {
  return (
    <>
      <ConsentBanner />
      {children}
    </>
  );
}
